<template>
  <div>
    <div
      class="hover:ts-shadow-md ts-border ts-cursor-pointer ts-border-gray-300 ts-mb-4 ts-rounded-md ts-overflow-hidden ts-mx-auto ts-px-3 ts-py-2 ts-w-1/2"
    >
      <div class="ts-pt-1/2 ts-relative">
        <label
          for="logo-image"
          class="ts-w-full ts-h-full ts-cursor-pointer ts-absolute ts-top-0"
        >
          <img
            id="logo"
            class="ts-w-full ts-h-full ts-object-contain"
            :src="logo_file_src"
            alt
          />
        </label>
      </div>
      <input
        type="file"
        id="logo-image"
        ref="logoimage"
        style="display: none"
        @change="onFileChange"
      />
    </div>
    <div class="ts-space-y-2">
      <div class="row">
        <div class="col-md-12">
          <label class="ts-text-xs">{{ $t('luckyDrawItem.itemNameKh') }}</label>
          <input
            type="text"
            class="form-control"
            v-model.trim="model.item_name_kh"
          />
          <div class="validate ts-text-xs" v-if="errors.has('item_name_kh')">
            {{ errors.first('item_name_kh') }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label class="required ts-text-xs">
            {{ $t('luckyDrawItem.itemNameEn') }}
          </label>
          <input
            type="text"
            class="form-control"
            v-model.trim="model.item_name_en"
          />
          <div class="validate ts-text-xs" v-if="errors.has('item_name_en')">
            {{ errors.first('item_name_en') }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label class="required ts-text-xs">
            {{ $t('luckyDrawItem.congratulationText') }}
          </label>
          <input
            type="text"
            class="form-control"
            v-model.trim="model.congratulation_text"
          />
          <div
            class="validate ts-text-xs"
            v-if="errors.has('congratulation_text')"
          >
            {{ errors.first('congratulation_text') }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <ts-checkbox v-model="model.is_enable">{{
            $t('luckyDrawItem.isEnable')
          }}</ts-checkbox>
          <ts-checkbox v-model="model.is_popup_prize_box">{{
            $t('luckyDrawItem.isPopupPrizeBox')
          }}</ts-checkbox>
          <ts-checkbox v-model="model.is_rotation">{{
            $t('luckyDrawItem.isRotation')
          }}</ts-checkbox>
          <div class="validate ts-text-xs" v-if="errors.has('is_enable')">
            {{ errors.first('is_enable') }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 ts-mt-3 text-right">
          <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
            {{ $t('cancel') }}
          </ts-button>
          <ts-button
            v-if="!isUpdate"
            color="primary"
            @click.prevent="onSave"
            :waiting="waiting"
            >{{ $t('save') }}</ts-button
          >
          <ts-button
            v-if="isUpdate"
            color="primary"
            @click.prevent="onUpdate"
            :waiting="waiting"
            >{{ $t('update') }}</ts-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

export default {
  name: 'companyForm',
  data () {
    return {
      errors: new Errors(),
      logo_file: null,
      logo_file_src: require('../../../assets/upload.png'),
      waiting: false,
      model: {
        item_name_kh: null,
        item_name_en: null,
        photo: null,
        is_enable: true,
        congratulation_text: null,
        is_popup_prize_box: true,
        is_rotation: false
      }
    }
  },
  created () {
    this.setEditData()
  },
  computed: {
    ...mapState('luckyDraw/luckyDrawItem', ['edit_data']),
    isUpdate () {
      return !_.isEmpty(this.edit_data)
    }
  },
  methods: {
    onFileChange () {
      const file = this.$refs.logoimage.files[0]
      let reader = new FileReader()
      reader.addEventListener(
        'load',
        function () {
          this.logo_file_src = reader.result
        }.bind(this),
        false
      )
      if (file) {
        if (/\.(jpe?g|png)$/i.test(file.name)) {
          reader.readAsDataURL(file)
          this.logo_file = file
        } else {
          this.logo_file_src = require('../../../assets/upload.png')
          this.$toasted.error('invalid file type!')
          this.$refs.logo_file.value = ''
        }
      }
    },
    async uploadLogo () {
      if ((this.logo_file instanceof File) | Blob) {
        let formData = new FormData()
        formData.append('file', this.logo_file)
        let response = await this.$store.dispatch(
          'luckyDraw/luckyDrawItem/upload',
          formData
        )
        this.model.photo = response
      }
      return ''
    },
    async onSave () {
      this.waiting = true
      await this.uploadLogo()
      this.$store
        .dispatch('luckyDraw/luckyDrawItem/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    async onUpdate () {
      this.waiting = true
      await this.uploadLogo()
      this.$store
        .dispatch('luckyDraw/luckyDrawItem/update', {
          id: this.edit_data.item_id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData () {
      if (!_.isEmpty(this.edit_data)) {
        this.model.item_name_kh = this.edit_data.item_name_kh
        this.model.item_name_en = this.edit_data.item_name_en
        this.model.is_enable = this.edit_data.is_enable
        this.model.congratulation_text = this.edit_data.congratulation_text
        this.model.is_popup_prize_box = this.edit_data.is_popup_prize_box
        this.model.is_rotation = this.edit_data.is_rotation
        this.model.photo = this.edit_data.photo
        if (this.edit_data.photo) {
          this.logo_file_src = this.edit_data.photo
        }
      }
    }
  }
}
</script>
